import { EduCoursesCollectionEffect } from './edu-courses/edu-courses.effect';
import { EduCoursePaymentsCollectionEffect } from './edu-course-payments/edu-course-payments.effect';
import { TestimonialsCollectionEffect } from './testimonials/testimonials.effect';
import { SitesCollectionEffect } from './sites/sites.effect';
import { ChatBotsCollectionEffect } from './chat-bots/chat-bots.effect';
import { ChatBotChainsCollectionEffect } from './chat-bot-chains/chat-bot-chains.effect';
import { EduSchoolsCollectionEffect } from './edu-schools/edu-schools.effect';
import { EduCoursesTariffsEffect } from './edu-courses-tariffs/edu-courses-tariffs.effect';

export const CollectionsEffects = [
    EduCoursesCollectionEffect,
    EduCoursePaymentsCollectionEffect,
    TestimonialsCollectionEffect,
    SitesCollectionEffect,
    ChatBotsCollectionEffect,
    ChatBotChainsCollectionEffect,
    EduSchoolsCollectionEffect,
    EduCoursesTariffsEffect,
];
